import React, { FC } from 'react';
import Form from 'components/Form';

import { LysolPageProps } from './models';

import 'styles/main.scss';
import './styles.scss';

const Lysol: FC<LysolPageProps> = ({ pageContext, location }) => (
  <Form {...{ ...pageContext, location }} />
);

export default Lysol;
